export class AppContext {
  public LicKey: string;
  public CustomerId: number;
  public Internal: boolean;
  public DatabaseName: string;
  public DatabaseServerName: string;
  public SiteId: string;
  public WebRoot: string;
  public WebRootSecure: string;
  public FolderPath_MediaFolderLocalFolderPath: string;
  public RelativeURL_MediaFolder: string;
  public FullURL_MediaFolder: string;
  public FullSecureURL_MediaFolder: string;
  public FolderPath_ImagesFolderLocalFolderPath: string;
  public RelativeURL_ImagesFolder: string;
  public FullURL_ImagesFolder: string;
  public FullSecureURL_ImagesFolder: string;
  public FolderPath_DocumentsFolderLocalFolderPath: string;
  public RelativeURL_DocumentsFolder: string;
  public FullURL_DocumentsFolder: string;
  public FullSecureURL_DocumentsFolder: string;
  public FolderPath_AudioFolderLocalFolderPath: string;
  public RelativeURL_AudioFolder: string;
  public FullURL_AudioFolder: string;
  public FullSecureURL_AudioFolder: string;
  public FolderPath_VideoFolderLocalFolderPath: string;
  public RelativeURL_VideoFolder: string;
  public FullURL_VideoFolder: string;
  public FullSecureURL_VideoFolder: string;
  public FolderPath_TempFolderLocalFolderPath: string;
  public RelativeURL_TempFolder: string;
  public FullURL_TempFolder: string;
  public FullSecureURL_TempFolder: string;
  public FolderPath_ReportFolderLocalFolderPath: string;
  public RelativeURL_ReportFolder: string;
  public FullURL_ReportFolder: string;
  public FullSecureURL_ReportFolder: string;
  public FolderPath_ReportCustomFolderLocalFolderPath: string;
  public RelativeURL_ReportCustomFolder: string;
  public FullURL_ReportCustomFolder: string;
  public FullSecureURL_ReportCustomFolder: string;
  public CorpProfileId: number = 0;

  public constructor() {
    this.LicKey = '';
    this.CustomerId = 0;

    this.DatabaseName = '';
    this.DatabaseServerName = '';

    this.SiteId = '';
    this.WebRoot = '';
    this.WebRootSecure = '';
    this.FolderPath_MediaFolderLocalFolderPath = '';
    this.RelativeURL_MediaFolder = '';
    this.FullURL_MediaFolder = '';
    this.FullSecureURL_MediaFolder = '';
    this.FolderPath_ImagesFolderLocalFolderPath = '';
    this.RelativeURL_ImagesFolder = '';
    this.FullURL_ImagesFolder = '';
    this.FullSecureURL_ImagesFolder = '';
    this.FolderPath_DocumentsFolderLocalFolderPath = '';
    this.RelativeURL_DocumentsFolder = '';
    this.FullURL_DocumentsFolder = '';
    this.FullSecureURL_DocumentsFolder = '';
    this.FolderPath_AudioFolderLocalFolderPath = '';
    this.RelativeURL_AudioFolder = '';
    this.FullURL_AudioFolder = '';
    this.FullSecureURL_AudioFolder = '';
    this.FolderPath_VideoFolderLocalFolderPath = '';
    this.RelativeURL_VideoFolder = '';
    this.FullURL_VideoFolder = '';
    this.FullSecureURL_VideoFolder = '';
    this.FolderPath_TempFolderLocalFolderPath = '';
    this.RelativeURL_TempFolder = '';
    this.FullURL_TempFolder = '';
    this.FullSecureURL_TempFolder = '';
    this.FolderPath_ReportFolderLocalFolderPath = '';
    this.RelativeURL_ReportFolder = '';
    this.FullURL_ReportFolder = '';
    this.FullSecureURL_ReportFolder = '';
    this.FolderPath_ReportCustomFolderLocalFolderPath = '';
    this.RelativeURL_ReportCustomFolder = '';
    this.FullURL_ReportCustomFolder = '';
    this.FullSecureURL_ReportCustomFolder = '';
  }
}
